/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-tumblr': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.125 17.5h-2.5c-2.244 0-3.938-1.163-3.938-3.938v-4.45H5.626V6.7a4.481 4.481 0 003.313-4.2h2.35v3.825h2.724v2.788h-2.725v3.875c0 1.162.588 1.556 1.513 1.556h1.325V17.5z"/>'
  }
})
